import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import addMonths from "date-fns/add_months";
import _ from 'lodash'
import { getCategory, getTeamByCompany } from './core/cacheService';
import { resolveTeamHeightFromTeams } from '@/utils/teamHeight'
export default {
    namespaced: true,
    state: {
        teamHeight: '',
        QuarterOfMonth: {
            1:"1",
            2:"1",
            3:"1",
            4:"2",
            5:"2",
            6:"2",
            7:"3",
            8:"3",
            9:"3",
            10:"4",
            11:"4",
            12:"4"
        },
        recommendLabel: {},
        loadingStrengthData: true,
        arrQuarter: [],
        questionMasterByCategory: [],
        questionType: [],
        categoryMaster: {},
        questionMaster: {},
        questionSet1:{ // WHO-5
            1:'-MdMv_XgThL0o2iunlhE',
            2:'-MdMw8kfpZtxnppGUA1f',
            3:'-MdMyavdF-YvuyzW6cA5',
            4:'-MdMz-TodEXbj3AC68oP',
            5:'-MdMzwfySVTjhOAGoxTP'
        },
        questionSet2:{ // eRes
            1:'-MgaSDDhL-3mt78QHuYL',
            2:'-MgaSw_L3eW0WyF4ZplB',
            3:'-MgaTQObIM08enQK5p3F',
            4:'-MgaU6mpwzOgerV7w-IW',
            5:'-MgaUfGLnzhU0BcUv5Db'
        },
        enpsQusetionData: [],
        normalQusetionData: [],
    },
    mutations: {
        setQuarterHeader(state: any, value: any) {
            state.recommendLabel = value
        },
        setArrQuarter(state: any, value: any) {
            state.arrQuarter = value
        },
        setLoadingStrengthData(state: any, value: any) {
            state.loadingStrengthData = value
        },
        setTeamHeight(state: any, value: any) {
            state.teamHeight = value
        },
        setQuestionType(state: any, value: any) {
            state.questionType = value
        },
        setCategoryMaster(state: any, result: any) {
            state.categoryMaster = result
        },
        setQuestionMaster(state: any, result: any) {
            state.questionMaster = result
        },
        setQuestionMasterByCategory(state: any, result: any) {
            state.questionMasterByCategory = result
        },
        setEnpsQusetionData(state: any, value: any) {
            state.enpsQusetionData = value
        },
        setNormalQusetionData(state: any, value: any) {
            state.normalQusetionData = value
        },
    },
    actions: {
        async getQuestionMaster({ commit, dispatch, rootState, state }: any) {
            const categoryMaster = await getCategory()//(await firebase.database().ref('category').once('value')).val()
            let categorySort: Array<any> = []
            const questionType: Array<any> = [];
            const dataMaster = {}
            const dataMasterByCategory: Array<any> = []
            dataMasterByCategory['nps'] = new Object()
            dataMasterByCategory['set1'] = new Object()
            firebase.database().ref('questions').orderByChild('report_card').equalTo('Y').once('value', snapshot => {
                snapshot.forEach((doc): any => {
                    const data = doc.val()
                    data.key = doc.key
                    dataMaster[data.key] = data.report_card_label
                    if(dataMasterByCategory[data.category] == undefined){
                        dataMasterByCategory[data.category] = new Object()
                        categorySort.push({category_id: data.category,category_name: categoryMaster[data.category].category})
                    }
                    if(data.nps !== undefined){
                        dataMasterByCategory['nps'][data.key] = data.report_card_label
                    }else{
                        if(_.find(state.questionSet1, function(o) { return o === data.key; })){ //WHO-5
                            dataMaster['WHO-5'] = data.report_card_label
                            dataMasterByCategory['set1']['WHO-5'] = data.report_card_label
                        }else if(_.find(state.questionSet2, function(o) { return o === data.key; })){  //eRes
                            dataMaster['eRes'] = data.report_card_label
                            dataMasterByCategory['set1']['eRes'] = data.report_card_label
                        }else{
                            dataMasterByCategory[data.category][data.key] = data.report_card_label
                        }
                    }
                    if(questionType[data.key] == undefined){
                        if(data.nps !== undefined){
                            if(data.nps == 'eNPS'){
                                questionType[data.key] = 'eNPS'
                            }else{
                                questionType[data.key] = 'NPS'
                            }
                            
                        }else{
                            if(_.find(state.questionSet1, function(o) { return o === data.key; })){
                                questionType['WHO-5'] = 'WHO-5'
                            }else if(_.find(state.questionSet2, function(o) { return o === data.key; })){  //eRes
                                questionType['eRes'] = 'eRes'
                            }else{
                                questionType[data.key] = data.type
                            }
                            
                        }
                    }
                });
                categorySort = _.orderBy(categorySort,['category_name'], ['asc'])
                categorySort.unshift({category_id: 'set1',category_name: 'set1'})
                categorySort.unshift({category_id: 'nps',category_name: 'nps'})
                const results: Array<any> = []
                _.forEach(categorySort, (value)=> {
                    results[value.category_id] = dataMasterByCategory[value.category_id]
                });
                commit('setQuestionType', questionType)
                commit('setCategoryMaster', categoryMaster)
                commit('setQuestionMaster', dataMaster)
                commit('setQuestionMasterByCategory', results)
              });
        },
        getQuaterHeader({commit,dispatch,state}:any, user:any){
            const arrQuarter: Array<any> = [];
            let ObjQuarter = {}
            let thisYear = user.year
            let m = user.num_month * 1
            let quarterEnd = thisYear+state.QuarterOfMonth[m]
            let year = Number(user.year)
            let runQ = Number(quarterEnd.substr(4,1))
            for(var i = 1; i < 5; i++){
                if(runQ < 1){
                    runQ = 4
                    year = year - 1
                }
                ObjQuarter[`q`+i+`Label`] = "Q"+runQ+" "+year
                arrQuarter.push(String(year)+String(runQ))
                runQ--
            }
            commit('setQuarterHeader', ObjQuarter)
            commit('setArrQuarter', arrQuarter)
        },
        async getDataStrength({commit, dispatch, rootState, state}:any, user:any){
            let selectTeam:any = ''
            if(!state.teamHeight){
                if (!state.teamHeight && rootState.main.teamHeight) {
                    selectTeam = rootState.main.teamHeight
                    commit('setTeamHeight', selectTeam)
                }
                if(!state.teamHeight){
                    if(rootState.team.teamsall.length >0){
                        selectTeam = resolveTeamHeightFromTeams(rootState.team.teamsall)
                        commit('setTeamHeight', selectTeam)
                        if (selectTeam) {
                            commit('main/setTeamHeight', selectTeam, { root: true })
                        }
                    }else{
                        try{
                            const team = await getTeamByCompany(user.company)
                            selectTeam = resolveTeamHeightFromTeams(team)
                            commit('setTeamHeight', selectTeam)
                            if (selectTeam) {
                                commit('main/setTeamHeight', selectTeam, { root: true })
                            }
                        }catch(error){
                          console.log(error)
                        }
                    }
                }
            }else{
                selectTeam = state.teamHeight
            }
            const allTeam = await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(`${user.company}`).once('value')).val()
            const teamUser = user.teamid
            const teamUserParent: Array<any> = [];
            ////  Data of Top Team
            let setStartDate = user.year+"-"+user.num_month+"-31"
            let setEndDate = format(addMonths(setStartDate, -24), "YYYY-MM") + "-01";
            var promise1 = new Promise(function(resolve, reject) {
                const data1: Array<any> = [];
                firebase.firestore().collection('insight_teams_report_card').where("company", "==", user.company).where("team", "==", selectTeam).where("quarter", ">=", Number(state.arrQuarter[3])).where("quarter", "<=", Number(state.arrQuarter[0])).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(allTeam[data.team] && data.date <= setStartDate){
                                if(data1[data.quarter] == undefined){
                                    data1[data.quarter] = new Array()
                                }
                                data1[data.quarter][data.team+"_"+data.quest_id] = data
                            }
                        });
                    resolve(data1);
                });
            });
            var promise2 = new Promise(function(resolve, reject) {
                const data2: Array<any> = [];
                firebase.firestore().collection('insight_teams_report_card').where("company", "==", user.company).where("team", "==", teamUser).where("quarter", ">=", Number(state.arrQuarter[3])).where("quarter", "<=", Number(state.arrQuarter[0])).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(allTeam[data.team] && data.date <= setStartDate){
                                if(data2[data.quarter] == undefined){
                                    data2[data.quarter] = new Array()
                                }
                                data2[data.quarter][data.team+"_"+data.quest_id] = data
                            }
                        });
                    resolve(data2);
                });
            });
            ////  Data of team parent
            var promise3 = new Promise(function(resolve, reject) {
                const data3: Array<any> = [];
                firebase.firestore().collection('insight_teams_report_card').where("company", "==", user.company).where("parent_team", "==", teamUser).where("quarter", ">=", Number(state.arrQuarter[3])).where("quarter", "<=", Number(state.arrQuarter[0])).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(allTeam[data.team] && data.date <= setStartDate){
                                if(data3[data.quarter] == undefined){
                                    data3[data.quarter] = new Array()
                                }
                                if(teamUserParent[data.team] == undefined){
                                    teamUserParent[data.team] = data.team
                                }
                                data3[data.quarter][data.team+"_"+data.quest_id] = data
                            }
                            
                        });
                    resolve(data3);
                });
            });
            
            Promise.all([promise1, promise2, promise3]).then((values)=> {
                const dataTopTeam:any = values[0]
                const dataUserTeam:any = values[1]
                const dataParentTeam:any = values[2]
                var temp_quarter = 0
                do{
                    if(dataUserTeam[state.arrQuarter[temp_quarter]]){
                        break
                    }else{
                        temp_quarter++
                    }
                }
                while(dataUserTeam && temp_quarter < 4)
                const userTeamResult: Array<any> = [];
                const userTeamResultStrength: Array<any> = [];
                const userTeamResultChallenge: Array<any> = [];
                const strengthDataSub: Array<any> = [];
                const challengeDataSub: Array<any> = [];
                if(dataUserTeam && dataUserTeam[state.arrQuarter[temp_quarter]] !== undefined){
                    _.forOwn(state.questionMaster, function(item, quest_id) {
                        let userKey = teamUser+"_"+quest_id
                        let userValue = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][userKey]) ? dataUserTeam[state.arrQuarter[temp_quarter]][userKey] : {}
                        let topTeamKey = selectTeam+"_"+quest_id
                        let topTeamValue = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][topTeamKey]) ? dataTopTeam[state.arrQuarter[temp_quarter]][topTeamKey] : {}
                        if(Object.keys(userValue).length !== 0 && Object.keys(topTeamValue).length !== 0){
                            if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                let nps_score_user:any = 0
                                let nps_score_top_team:any = 0
                                if(userValue.answer && Object.keys(userValue.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    _.forEach(userValue.answer, function (response, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= response
                                        }else if(key >=9 && key <= 10){
                                            promotors+= response
                                        }
                                    });
                                    nps_score_user =((promotors / Number(userValue.total)) - (detractors / Number(userValue.total)))*100
                                }
                                if(topTeamValue.answer && Object.keys(topTeamValue.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    _.forEach(topTeamValue.answer, function (response, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= response
                                        }else if(key >=9 && key <= 10){
                                            promotors+= response
                                        }
                                    });
                                    nps_score_top_team = ((promotors / Number(topTeamValue.total)) - (detractors / Number(topTeamValue.total)))*100
                                }
                                let total:any = Math.ceil(nps_score_user) - Math.ceil(nps_score_top_team)
                                if(total > 0){
                                    if(nps_score_user >= 30){
                                        userTeamResultStrength[quest_id] = total
                                    }
                                }else if(total < 0){
                                    if(nps_score_user < 30){
                                        userTeamResultChallenge[quest_id] = total
                                    }
                                }else{
                                    if(nps_score_user >= 30){
                                        strengthDataSub[quest_id] = total
                                    }else{
                                        challengeDataSub[quest_id] = total
                                    }
                                }
                                userTeamResult[quest_id] = total
                            }else if(_.find(state.questionSet1, function(o) { return o === quest_id; }) && userTeamResult['WHO-5'] == undefined) { //WHO-5
                                const dataTeamSelectUser: Array<any> = [];
                                let percentUser:any = 0
                                let percentTopTeam:any = 0
                                let dataSumUser:any = 0;
                                let dataSumTopTeam:any = 0;
                                let maxmimumUser:any = 0;
                                let maxmimumTopTeam:any = 0;
                                
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet1[1]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet1[2]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet1[3]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet1[4]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet1[5]])
                                if(Object.keys(dataTeamSelectUser[0]).length > 0 && Object.keys(dataTeamSelectUser[1]).length > 0 && Object.keys(dataTeamSelectUser[2]).length > 0 && Object.keys(dataTeamSelectUser[3]).length > 0 && Object.keys(dataTeamSelectUser[4]).length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelectUser[x] && dataTeamSelectUser[x].answer && Object.keys(dataTeamSelectUser[x].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelectUser[x].answer[y]){
                                                    dataSumUser += (dataTeamSelectUser[x].answer[y]) * (5 - y)
                                                    maxmimumUser += dataTeamSelectUser[x].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    percentUser = ((dataSumUser * 100) / maxmimumUser);
                                }else{
                                    percentUser = 0
                                }

                                const dataTeamSelectTopTeam: Array<any> = [];
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet1[1]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet1[2]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet1[3]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet1[4]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet1[5]])
                                if(Object.keys(dataTeamSelectTopTeam[0]).length > 0 && Object.keys(dataTeamSelectTopTeam[1]).length > 0 && Object.keys(dataTeamSelectTopTeam[2]).length > 0 && Object.keys(dataTeamSelectTopTeam[3]).length > 0 && Object.keys(dataTeamSelectTopTeam[4]).length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelectTopTeam[x] && dataTeamSelectTopTeam[x].answer && Object.keys(dataTeamSelectTopTeam[x].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelectTopTeam[x].answer[y]){
                                                    dataSumTopTeam += (dataTeamSelectTopTeam[x].answer[y]) * (5 - y)
                                                    maxmimumTopTeam += dataTeamSelectTopTeam[x].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    percentTopTeam = ((dataSumTopTeam * 100) / maxmimumTopTeam);
                                }else{
                                    percentTopTeam = 0
                                }
                                let total:any = (percentUser.toFixed(1) * 1) - (percentTopTeam.toFixed(1) * 1)
                                if(total > 0){
                                    if(percentUser >= 80){
                                        userTeamResultStrength['WHO-5'] = total
                                    }
                                }else if(total < 0){
                                    if(percentUser < 80){
                                        userTeamResultChallenge['WHO-5'] = total
                                    }
                                }else{
                                    if(percentUser >= 80){
                                        strengthDataSub['WHO-5'] = total
                                    }else{
                                        challengeDataSub['WHO-5'] = total
                                    }
                                }
                                userTeamResult['WHO-5'] = total
                            }else if(_.find(state.questionSet2, function(o) { return o === quest_id; }) && userTeamResult['eRes'] == undefined) { //eRes
                                const dataTeamSelectUser: Array<any> = [];
                                let percentUser:any = 0
                                let percentTopTeam:any = 0
                                let dataSumUser:any = 0;
                                let dataSumTopTeam:any = 0;
                                let maxmimumUser:any = 0;
                                let maxmimumTopTeam:any = 0;
                                
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet2[1]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet2[2]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet2[3]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet2[4]])
                                dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][userValue.team+"_"+state.questionSet2[5]])
                                if(Object.keys(dataTeamSelectUser[0]).length > 0 && Object.keys(dataTeamSelectUser[1]).length > 0 && Object.keys(dataTeamSelectUser[2]).length > 0 && Object.keys(dataTeamSelectUser[3]).length > 0 && Object.keys(dataTeamSelectUser[4]).length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelectUser[x] && dataTeamSelectUser[x].answer && Object.keys(dataTeamSelectUser[x].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelectUser[x].answer[y]){
                                                    dataSumUser += (dataTeamSelectUser[x].answer[y]) * (5 - y)
                                                    maxmimumUser += dataTeamSelectUser[x].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    percentUser = ((dataSumUser * 100) / maxmimumUser);
                                }else{
                                    percentUser = 0
                                }

                                const dataTeamSelectTopTeam: Array<any> = [];
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet2[1]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet2[2]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet2[3]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet2[4]])
                                dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][topTeamValue.team+"_"+state.questionSet2[5]])
                                if(Object.keys(dataTeamSelectTopTeam[0]).length > 0 && Object.keys(dataTeamSelectTopTeam[1]).length > 0 && Object.keys(dataTeamSelectTopTeam[2]).length > 0 && Object.keys(dataTeamSelectTopTeam[3]).length > 0 && Object.keys(dataTeamSelectTopTeam[4]).length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelectTopTeam[x] && dataTeamSelectTopTeam[x].answer && Object.keys(dataTeamSelectTopTeam[x].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelectTopTeam[x].answer[y]){
                                                    dataSumTopTeam += (dataTeamSelectTopTeam[x].answer[y]) * (5 - y)
                                                    maxmimumTopTeam += dataTeamSelectTopTeam[x].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    percentTopTeam = ((dataSumTopTeam * 100) / maxmimumTopTeam);
                                }else{
                                    percentTopTeam = 0
                                }
                                let total:any = (percentUser.toFixed(1) * 1) - (percentTopTeam.toFixed(1) * 1)
                                if(total > 0){
                                    if(percentUser >= 80){
                                        userTeamResultStrength['eRes'] = total
                                    }
                                }else if(total < 0){
                                    if(percentUser < 80){
                                        userTeamResultChallenge['eRes'] = total
                                    }
                                }else{
                                    if(percentUser >= 80){
                                        strengthDataSub['eRes'] = total
                                    }else{
                                        challengeDataSub['eRes'] = total
                                    }
                                }
                                userTeamResult['eRes'] = total
                            } else {
                                if(!_.find(state.questionSet1, function(o) { return o === quest_id; }) && !_.find(state.questionSet2, function(o) { return o === quest_id; })){
                                    if(state.questionType[quest_id] == 'Scale'){
                                        let total:any = (userValue.percent.toFixed(1) * 10) - (topTeamValue.percent.toFixed(1) * 10)
                                        if(total > 0){
                                            if(userValue.percent >= 7){
                                                userTeamResultStrength[quest_id] = total
                                            }
                                        }else if(total < 0){
                                            if(userValue.percent < 7){
                                                userTeamResultChallenge[quest_id] = total
                                            }
                                        }else{
                                            if(userValue.percent >= 7){
                                                strengthDataSub[quest_id] = total
                                            }else{
                                                challengeDataSub[quest_id] = total
                                            }
                                        }
                                        userTeamResult[quest_id] = total
                                    }else{
                                        let total:any = Math.ceil(userValue.percent) - Math.ceil(topTeamValue.percent)
                                        if(total > 0){
                                            if(userValue.percent >= 70){
                                                userTeamResultStrength[quest_id] = total
                                            }
                                        }else if(total < 0){
                                            if(userValue.percent < 70){
                                                userTeamResultChallenge[quest_id] = total
                                            }
                                        }else{
                                            if(userValue.percent >= 70){
                                                strengthDataSub[quest_id] = total
                                            }else{
                                                challengeDataSub[quest_id] = total
                                            }
                                        }
                                        userTeamResult[quest_id] = total
                                    }
                                }
                            }
                        }
                    });
                }
                // Strength Calculate //
                let resultsStrength: Array<any> = [];
                let resultsStrengthIndex: Array<any> = [];
                let resultsStrengthSum: Array<any> = [];
                let resultsStrengthSumIndex: Array<any> = [];
                _.forOwn(userTeamResultStrength, function(percent, quest_id) {
                    if((state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]) || quest_id == 'WHO-5' || quest_id == 'eRes'){
                        resultsStrengthIndex.push({'quest_id': quest_id, 'percent': percent})
                    }else{
                        resultsStrength.push({'quest_id': quest_id, 'percent': percent})
                    }
                });
                _.forOwn(strengthDataSub, function(percent, quest_id) {
                    if((state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]) || quest_id == 'WHO-5' || quest_id == 'eRes'){
                        resultsStrengthSumIndex.push({'quest_id': quest_id, 'percent': percent})
                    }else{
                        resultsStrengthSum.push({'quest_id': quest_id, 'percent': percent})
                    }
                });
                let arrStrength:any = []
                let arrStrengthIndex:any = []
                let arrStrengthIndexSum:any = []
                let temp_arrStrength:any = []
                if(resultsStrengthIndex.length > 0){
                    arrStrengthIndex = (_.sortBy(resultsStrengthIndex, [function(o:any) { return o.percent; }]).reverse()).slice(0, 3)
                }
                if(arrStrengthIndex.length > 0){
                    temp_arrStrength = (_.sortBy(resultsStrength, [function(o:any) { return o.percent; }]).reverse()).slice(0, (3 - arrStrengthIndex.length))
                    arrStrength = _.concat(arrStrengthIndex,temp_arrStrength)
                }else{
                    arrStrength = (_.sortBy(resultsStrength, [function(o:any) { return o.percent; }]).reverse()).slice(0, 3)
                }
                if(arrStrength.length < 3){
                    let _tmp:any = []
                    if(resultsStrengthSumIndex.length > 0){
                        arrStrengthIndexSum = (_.sortBy(resultsStrengthSumIndex, [function(o:any) { return o.percent; }]).reverse()).slice(0, (3 - arrStrength.length))
                        arrStrength = _.concat(arrStrength,arrStrengthIndexSum)
                    }
                    if(arrStrength.length < 3){
                        if(resultsStrengthSum.length > 0){
                            _tmp = (_.sortBy(resultsStrengthSum, [function(o:any) { return o.percent; }]).reverse()).slice(0, (3 - arrStrength.length))
                            arrStrength = _.concat(arrStrength,_tmp)
                        }
                    }
                }

                let arrDataStrength: Array<any> = [];
                _.forEach(arrStrength, (item,index)=> {
                    let quest_id = item.quest_id
                    let obj = {}
                    obj['questionTitile'] = state.questionMaster[quest_id] || ''
                    obj['id'] = item.quest_id
                    obj['icon'] = '💪'
                    obj['tableData'] = new Array()
                    let objDataTopTeam = {}
                    objDataTopTeam['id'] = selectTeam
                    let objDataUserTeam = {}
                    objDataUserTeam['id'] = teamUser
                    ///for TopTeam///
                    let topTeamKey = selectTeam+"_"+quest_id
                    let dataArrow: Array<any> = [];
                    let checkArrow:any = false
                    for(var i = 0; i < 4; i++){
                        if(i == 0){
                            dataArrow.push(i)
                        }else{
                            if(dataTopTeam[state.arrQuarter[i]] && dataTopTeam[state.arrQuarter[i]][topTeamKey] && dataArrow.length < 2){
                                dataArrow.push(i)
                                if(dataArrow.length == 2){
                                    checkArrow = true
                                }
                            }
                        }
                    }
                    _.forEach(state.arrQuarter, (year_quarter,temp_quarter)=> {
                        let topTeamValue = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][topTeamKey]) ? dataTopTeam[state.arrQuarter[temp_quarter]][topTeamKey] : {}
                        if(Object.keys(topTeamValue).length !== 0 || quest_id == 'WHO-5' || quest_id == 'eRes'){
                            if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                let nps_score_top_team:any = 0
                                if(topTeamValue.answer && Object.keys(topTeamValue.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    _.forEach(topTeamValue.answer, function (response, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= response
                                        }else if(key >=9 && key <= 10){
                                            promotors+= response
                                        }
                                    });
                                    nps_score_top_team = ((promotors / Number(topTeamValue.total)) - (detractors / Number(topTeamValue.total)))*100
                                }
                                let total:any = Math.ceil(nps_score_top_team)
                                objDataTopTeam[`q`+(temp_quarter+1)] = total
                                if(total >= -100 && total <= 0){
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                }else if(total > 0 && total < 30){
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                }else if(total >= 30){
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                }else{
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'WHO-5') { //WHO-5
                                let checkData = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[1]]) ? dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[1]] : ''
                                if(checkData){
                                    let percentTopTeam:any = 0
                                    let dataSumTopTeam:any = 0;
                                    let maxmimumTopTeam:any = 0;
                                    const dataTeamSelectTopTeam: Array<any> = [];
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[1]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[2]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[3]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[4]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[5]])
                                    if(Object.keys(dataTeamSelectTopTeam[0]).length > 0 && Object.keys(dataTeamSelectTopTeam[1]).length > 0 && Object.keys(dataTeamSelectTopTeam[2]).length > 0 && Object.keys(dataTeamSelectTopTeam[3]).length > 0 && Object.keys(dataTeamSelectTopTeam[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectTopTeam[x] && dataTeamSelectTopTeam[x].answer && Object.keys(dataTeamSelectTopTeam[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectTopTeam[x].answer[y]){
                                                        dataSumTopTeam += (dataTeamSelectTopTeam[x].answer[y]) * (5 - y)
                                                        maxmimumTopTeam += dataTeamSelectTopTeam[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentTopTeam = ((dataSumTopTeam * 100) / maxmimumTopTeam);
                                    }else{
                                        percentTopTeam = 0
                                    }
                                    let total:any = percentTopTeam.toFixed(1) * 1
                                    objDataTopTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'eRes') { //eRes
                                let checkData = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[1]]) ? dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[1]] : ''
                                if(checkData){
                                    let percentTopTeam:any = 0
                                    let dataSumTopTeam:any = 0;
                                    let maxmimumTopTeam:any = 0;
                                    const dataTeamSelectTopTeam: Array<any> = [];
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[1]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[2]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[3]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[4]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[5]])
                                    if(Object.keys(dataTeamSelectTopTeam[0]).length > 0 && Object.keys(dataTeamSelectTopTeam[1]).length > 0 && Object.keys(dataTeamSelectTopTeam[2]).length > 0 && Object.keys(dataTeamSelectTopTeam[3]).length > 0 && Object.keys(dataTeamSelectTopTeam[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectTopTeam[x] && dataTeamSelectTopTeam[x].answer && Object.keys(dataTeamSelectTopTeam[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectTopTeam[x].answer[y]){
                                                        dataSumTopTeam += (dataTeamSelectTopTeam[x].answer[y]) * (5 - y)
                                                        maxmimumTopTeam += dataTeamSelectTopTeam[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentTopTeam = ((dataSumTopTeam * 100) / maxmimumTopTeam);
                                    }else{
                                        percentTopTeam = 0
                                    }
                                    let total:any = percentTopTeam.toFixed(1) * 1
                                    objDataTopTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            } else {
                                if(state.questionType[quest_id] == 'Scale'){
                                    let total:any = topTeamValue.percent.toFixed(1) * 1
                                    objDataTopTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 5){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 5 && total < 7){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 7){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    if(Object.keys(topTeamValue).length !== 0){
                                        let total:any = Math.ceil(topTeamValue.percent)
                                        objDataTopTeam[`q`+(temp_quarter+1)] = total
                                        if(total >= 0 && total <= 50){
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                        }else if(total > 50 && total < 70){
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                        }else if(total >= 70){
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                        }else{
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                        }
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }
                                
                            }
                            if(state.questionType[quest_id] == 'NPS' || state.questionType[quest_id] == 'eNPS' || quest_id == 'WHO-5' || quest_id == 'eRes'){
                                if(objDataTopTeam[`q`+ (dataArrow[0] + 1)+`Status`] && objDataTopTeam[`q`+ (dataArrow[0] + 1)+`Status`] !== 'none'){
                                    obj['indexColor'] = objDataTopTeam[`q`+ (dataArrow[0] + 1)+`Status`]
                                }
                            }
                            if(checkArrow){
                                let quaterChange1:any = objDataTopTeam[`q`+ (dataArrow[0] + 1)]
                                let quaterChange2:any = objDataTopTeam[`q`+ (dataArrow[1] + 1)]
                                let totalChange:any = 0
                                if((quaterChange1 !== undefined) && (quaterChange2 !== undefined)){
                                    totalChange = quaterChange1 - quaterChange2
                                    if(totalChange == 0){
                                        objDataTopTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'minus'
                                    }else if(totalChange > 0){
                                        objDataTopTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'up'
                                    }else if(totalChange < 0){
                                        objDataTopTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'down'
                                    }
                                } 
                            }
                        }else{
                            objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                        }
                        ///for User Team ///
                        objDataTopTeam['children'] = new Array()
                        let userKey = teamUser+"_"+quest_id
                        let userValue = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][userKey]) ? dataUserTeam[state.arrQuarter[temp_quarter]][userKey] : {}
                        if(Object.keys(userValue).length !== 0  || quest_id == 'WHO-5' || quest_id == 'eRes'){
                            if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                let nps_score_user:any = 0
                                if(userValue.answer && Object.keys(userValue.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    _.forEach(userValue.answer, function (response, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= response
                                        }else if(key >=9 && key <= 10){
                                            promotors+= response
                                        }
                                    });
                                    nps_score_user =((promotors / Number(userValue.total)) - (detractors / Number(userValue.total)))*100
                                }
                                let total:any = Math.ceil(nps_score_user)
                                objDataUserTeam[`q`+(temp_quarter+1)] = total
                                if(total >= -100 && total <= 0){
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                }else if(total > 0 && total < 30){
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                }else if(total >= 30){
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                }else{
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'WHO-5') { //WHO-5
                                let checkData = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[1]]) ? dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[1]] : ''
                                if(checkData){
                                    const dataTeamSelectUser: Array<any> = [];
                                    let percentUser:any = 0
                                    let dataSumUser:any = 0;
                                    let maxmimumUser:any = 0;
                                    
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[1]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[2]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[3]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[4]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[5]])
                                    if(Object.keys(dataTeamSelectUser[0]).length > 0 && Object.keys(dataTeamSelectUser[1]).length > 0 && Object.keys(dataTeamSelectUser[2]).length > 0 && Object.keys(dataTeamSelectUser[3]).length > 0 && Object.keys(dataTeamSelectUser[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectUser[x] && dataTeamSelectUser[x].answer && Object.keys(dataTeamSelectUser[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectUser[x].answer[y]){
                                                        dataSumUser += (dataTeamSelectUser[x].answer[y]) * (5 - y)
                                                        maxmimumUser += dataTeamSelectUser[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentUser = ((dataSumUser * 100) / maxmimumUser);
                                    }else{
                                        percentUser = 0
                                    }
                                    let total:any = percentUser.toFixed(1) * 1
                                    objDataUserTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                                
                            }else if(quest_id == 'eRes') { //eRes
                                let checkData = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[1]]) ? dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[1]] : ''
                                if(checkData){
                                    const dataTeamSelectUser: Array<any> = [];
                                    let percentUser:any = 0
                                    let dataSumUser:any = 0;
                                    let maxmimumUser:any = 0;
                                    
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[1]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[2]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[3]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[4]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[5]])
                                    if(Object.keys(dataTeamSelectUser[0]).length > 0 && Object.keys(dataTeamSelectUser[1]).length > 0 && Object.keys(dataTeamSelectUser[2]).length > 0 && Object.keys(dataTeamSelectUser[3]).length > 0 && Object.keys(dataTeamSelectUser[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectUser[x] && dataTeamSelectUser[x].answer && Object.keys(dataTeamSelectUser[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectUser[x].answer[y]){
                                                        dataSumUser += (dataTeamSelectUser[x].answer[y]) * (5 - y)
                                                        maxmimumUser += dataTeamSelectUser[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentUser = ((dataSumUser * 100) / maxmimumUser);
                                    }else{
                                        percentUser = 0
                                    }
                                    let total:any = percentUser.toFixed(1) * 1
                                    objDataUserTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            } else {
                                if(state.questionType[quest_id] == 'Scale'){
                                    let total:any = (userValue.percent.toFixed(1)) * 1
                                    objDataUserTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 5){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 5 && total < 7){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 7){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    if(Object.keys(userValue).length !== 0){
                                        let total:any = Math.ceil(userValue.percent)
                                        objDataUserTeam[`q`+(temp_quarter+1)] = total
                                        if(total >= 0 && total <= 50){
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                        }else if(total > 50 && total < 70){
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                        }else if(total >= 70){
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                        }else{
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                        }
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                    
                                }
                            }
                            if(checkArrow){
                                let quaterChange1:any = objDataUserTeam[`q`+ (dataArrow[0] + 1)]
                                let quaterChange2:any = objDataUserTeam[`q`+ (dataArrow[1] + 1)]
                                let totalChange:any = 0
                                if((quaterChange1 !== undefined) && (quaterChange2 !== undefined)){
                                    totalChange = quaterChange1 - quaterChange2
                                    if(totalChange == 0){
                                        objDataUserTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'minus'
                                    }else if(totalChange > 0){
                                        objDataUserTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'up'
                                    }else if(totalChange < 0){
                                        objDataUserTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'down'
                                    }
                                } 
                            }
                        }else{
                            objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                        }
                    });
                    ///for Parent Team///
                    objDataUserTeam['children'] = new Array()
                    _.forOwn(teamUserParent, function(item_parent, teamParent) {
                        let objDataParentTeam = {}
                        objDataParentTeam['id'] = teamParent
                        _.forEach(state.arrQuarter, (year_quarter_parent,temp_quarter_parent)=> {
                            if(dataParentTeam && dataParentTeam[state.arrQuarter[temp_quarter_parent]] !== undefined){
                                let parentKey = teamParent+"_"+quest_id
                                let parentValue = (dataParentTeam[state.arrQuarter[temp_quarter_parent]] && dataParentTeam[state.arrQuarter[temp_quarter_parent]][parentKey]) ? dataParentTeam[state.arrQuarter[temp_quarter_parent]][parentKey] : {}
                                if(Object.keys(parentValue).length !== 0 || quest_id == 'WHO-5' || quest_id == 'eRes'){
                                    if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                        let nps_score_parent:any = 0
                                        if(parentValue.answer && Object.keys(parentValue.answer).length > 0){
                                            let promotors:any = 0
                                            let detractors:any = 0
                                            _.forEach(parentValue.answer, function (response, key:number) {
                                                if(key >= 0 && key <= 6){
                                                    detractors+= response
                                                }else if(key >=9 && key <= 10){
                                                    promotors+= response
                                                }
                                            });
                                            nps_score_parent =((promotors / Number(parentValue.total)) - (detractors / Number(parentValue.total)))*100
                                        }
                                        let total:any = Math.ceil(nps_score_parent)
                                        objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                        if(total >= -100 && total <= 0){
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                        }else if(total > 0 && total < 30){
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                        }else if(total >= 30){
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                        }else{
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                        }
                                    }else if(quest_id == 'WHO-5') { //WHO-5
                                        let checkData = dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[1]]
                                        if(checkData){
                                            const dataTeamSelectParent: Array<any> = [];
                                            let percentParent:any = 0
                                            let dataSumParent:any = 0;
                                            let maxmimumParent:any = 0;
                                            
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[1]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[2]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[3]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[4]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[5]])
                                            if(Object.keys(dataTeamSelectParent[0]).length > 0 && Object.keys(dataTeamSelectParent[1]).length > 0 && Object.keys(dataTeamSelectParent[2]).length > 0 && Object.keys(dataTeamSelectParent[3]).length > 0 && Object.keys(dataTeamSelectParent[4]).length > 0){
                                                for(let x=0; x<5; x++){
                                                    if(dataTeamSelectParent[x] && dataTeamSelectParent[x].answer && Object.keys(dataTeamSelectParent[x].answer).length > 0){
                                                        for(let y=0; y<6; y++){
                                                            if(dataTeamSelectParent[x].answer[y]){
                                                                dataSumParent += (dataTeamSelectParent[x].answer[y]) * (5 - y)
                                                                maxmimumParent += dataTeamSelectParent[x].answer[y] * 5
                                                            }
                                                        }
                                                    }
                                                }
                                                percentParent = ((dataSumParent * 100) / maxmimumParent);
                                            }else{
                                                percentParent = 0
                                            }
                                            let total:any = percentParent.toFixed(1) * 1
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                            if(total >= 0 && total <= 59){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                            }else if(total > 59 && total < 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                            }else if(total >= 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }else{
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                        }
                                    }else if(quest_id == 'eRes') { //eRes
                                        let checkData = dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[1]]
                                        if(checkData){
                                            const dataTeamSelectParent: Array<any> = [];
                                            let percentParent:any = 0
                                            let dataSumParent:any = 0;
                                            let maxmimumParent:any = 0;
                                            
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[1]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[2]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[3]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[4]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[5]])
                                            if(Object.keys(dataTeamSelectParent[0]).length > 0 && Object.keys(dataTeamSelectParent[1]).length > 0 && Object.keys(dataTeamSelectParent[2]).length > 0 && Object.keys(dataTeamSelectParent[3]).length > 0 && Object.keys(dataTeamSelectParent[4]).length > 0){
                                                for(let x=0; x<5; x++){
                                                    if(dataTeamSelectParent[x] && dataTeamSelectParent[x].answer && Object.keys(dataTeamSelectParent[x].answer).length > 0){
                                                        for(let y=0; y<6; y++){
                                                            if(dataTeamSelectParent[x].answer[y]){
                                                                dataSumParent += (dataTeamSelectParent[x].answer[y]) * (5 - y)
                                                                maxmimumParent += dataTeamSelectParent[x].answer[y] * 5
                                                            }
                                                        }
                                                    }
                                                }
                                                percentParent = ((dataSumParent * 100) / maxmimumParent);
                                            }else{
                                                percentParent = 0
                                            }
                                            let total:any = percentParent.toFixed(1) * 1
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                            if(total >= 0 && total <= 59){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                            }else if(total > 59 && total < 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                            }else if(total >= 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }else{
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                        }
                                    } else {
                                        if(state.questionType[quest_id] == 'Scale'){
                                            let total:any = (parentValue.percent.toFixed(1)) * 1
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                            if(total >= 0 && total <= 5){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                            }else if(total > 5 && total < 7){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                            }else if(total >= 7){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }else{
                                            if(Object.keys(parentValue).length !== 0){
                                                let total:any = Math.ceil(parentValue.percent)
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                                if(total >= 0 && total <= 50){
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                                }else if(total > 50 && total < 70){
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                                }else if(total >= 70){
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                                }else{
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                                }
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }
                                    }
                                }else{
                                    objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                }
                                if(checkArrow){
                                    let quaterChange1:any = objDataParentTeam[`q`+ (dataArrow[0] + 1)]
                                    let quaterChange2:any = objDataParentTeam[`q`+ (dataArrow[1] + 1)]
                                    let totalChange:any = 0
                                    if((quaterChange1 !== undefined) && (quaterChange2 !== undefined)){
                                        totalChange = quaterChange1 - quaterChange2
                                        if(totalChange == 0){
                                            objDataParentTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'minus'
                                        }else if(totalChange > 0){
                                            objDataParentTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'up'
                                        }else if(totalChange < 0){
                                            objDataParentTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'down'
                                        }
                                    } 
                                }
                            }else{
                                objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                            }
                        });
                        objDataParentTeam['teamName'] = allTeam[teamParent].name || ''
                        if(selectTeam == teamUser){
                            objDataTopTeam['children'].push(objDataParentTeam)
                        }else{
                            objDataUserTeam['children'].push(objDataParentTeam)
                        }
                        
                    });
                    objDataUserTeam['teamName'] = allTeam[teamUser].name || ''
                    if(selectTeam !== teamUser){
                        objDataTopTeam['children'].push(objDataUserTeam)
                    }
                    objDataTopTeam['teamName'] = allTeam[selectTeam].name || ''
                    obj['tableData'].push(objDataTopTeam)
                    arrDataStrength.push(obj)
                });

                // Challenger Calculate //
                let resultsChallenge: Array<any> = [];
                let resultsChallengeIndex: Array<any> = [];
                let resultsChallengeSum: Array<any> = [];
                let resultsChallengeSumIndex: Array<any> = [];
                _.forOwn(userTeamResultChallenge, function(percent, quest_id) {
                    if((state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]) || quest_id == 'WHO-5' || quest_id == 'eRes'){
                        resultsChallengeIndex.push({'quest_id': quest_id, 'percent': percent})
                    }else{
                        resultsChallenge.push({'quest_id': quest_id, 'percent': percent})
                    }
                });
                _.forOwn(challengeDataSub, function(percent, quest_id) {
                    if((state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]) || quest_id == 'WHO-5' || quest_id == 'eRes'){
                        resultsChallengeSumIndex.push({'quest_id': quest_id, 'percent': percent})
                    }else{
                        resultsChallengeSum.push({'quest_id': quest_id, 'percent': percent})
                    }
                });
                let arrChallenge:any = []
                let arrChallengeIndex:any = []
                let arrChallengeIndexSum:any = []
                let temp_arrChallenge:any = []
                if(resultsChallengeIndex.length > 0){
                    arrChallengeIndex = (_.sortBy(resultsChallengeIndex, [function(o:any) { return o.percent; }]).reverse()).slice(0, 3)
                }
                if(arrChallengeIndex.length > 0){
                    temp_arrChallenge = (_.sortBy(resultsChallenge, [function(o:any) { return o.percent; }]).reverse()).slice(0, (3 - arrChallengeIndex.length))
                    arrChallenge = _.concat(arrChallengeIndex,temp_arrChallenge)
                }else{
                    arrChallenge = (_.sortBy(resultsChallenge, [function(o:any) { return o.percent; }]).reverse()).slice(0, 3)
                }
                if(arrChallenge.length < 3){
                    let _tmp:any = []
                    if(resultsChallengeSumIndex.length > 0){
                        arrChallengeIndexSum = (_.sortBy(resultsChallengeSumIndex, [function(o:any) { return o.percent; }]).reverse()).slice(0, (3 - arrChallenge.length))
                        arrChallenge = _.concat(arrChallenge,arrChallengeIndexSum)
                    }
                    if(arrChallenge.length < 3){
                        if(resultsChallengeSum.length > 0){
                            _tmp = (_.sortBy(resultsChallengeSum, [function(o:any) { return o.percent; }]).reverse()).slice(0, (3 - arrChallenge.length))
                            arrChallenge = _.concat(arrChallenge,_tmp)
                        }
                    }
                }
                let arrDataChallenge: Array<any> = [];
                _.forEach(arrChallenge, (item,index)=> {
                    let quest_id = item.quest_id
                    let obj = {}
                    obj['questionTitile'] = state.questionMaster[quest_id] || ''
                    obj['id'] = item.quest_id
                    obj['icon'] = '⚠️'
                    obj['tableData'] = new Array()
                    let objDataTopTeam = {}
                    objDataTopTeam['id'] = selectTeam
                    let objDataUserTeam = {}
                    objDataUserTeam['id'] = teamUser
                    ///for TopTeam///
                    let topTeamKey = selectTeam+"_"+quest_id
                    let dataArrow: Array<any> = [];
                    let checkArrow:any = false
                    for(var i = 0; i < 4; i++){
                        if(i == 0){
                            dataArrow.push(i)
                        }else{
                            if(dataTopTeam[state.arrQuarter[i]] && dataTopTeam[state.arrQuarter[i]][topTeamKey] && dataArrow.length < 2){
                                dataArrow.push(i)
                                if(dataArrow.length == 2){
                                    checkArrow = true
                                }
                            }
                        }
                    }
                    _.forEach(state.arrQuarter, (year_quarter,temp_quarter)=> {
                        let topTeamValue = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][topTeamKey]) ? dataTopTeam[state.arrQuarter[temp_quarter]][topTeamKey] : {}
                        if(Object.keys(topTeamValue).length !== 0 || quest_id == 'WHO-5' || quest_id == 'eRes'){
                            if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                let nps_score_top_team:any = 0
                                if(topTeamValue.answer && Object.keys(topTeamValue.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    _.forEach(topTeamValue.answer, function (response, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= response
                                        }else if(key >=9 && key <= 10){
                                            promotors+= response
                                        }
                                    });
                                    nps_score_top_team = ((promotors / Number(topTeamValue.total)) - (detractors / Number(topTeamValue.total)))*100
                                }
                                let total:any = Math.ceil(nps_score_top_team)
                                objDataTopTeam[`q`+(temp_quarter+1)] = total
                                if(total >= -100 && total <= 0){
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                }else if(total > 0 && total < 30){
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                }else if(total >= 30){
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                }else{
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'WHO-5') { //WHO-5
                                let checkData = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[1]]) ? dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[1]] : ''
                                if(checkData){
                                    let percentTopTeam:any = 0
                                    let dataSumTopTeam:any = 0;
                                    let maxmimumTopTeam:any = 0;
                                    const dataTeamSelectTopTeam: Array<any> = [];
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[1]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[2]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[3]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[4]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet1[5]])
                                    if(Object.keys(dataTeamSelectTopTeam[0]).length > 0 && Object.keys(dataTeamSelectTopTeam[1]).length > 0 && Object.keys(dataTeamSelectTopTeam[2]).length > 0 && Object.keys(dataTeamSelectTopTeam[3]).length > 0 && Object.keys(dataTeamSelectTopTeam[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectTopTeam[x] && dataTeamSelectTopTeam[x].answer && Object.keys(dataTeamSelectTopTeam[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectTopTeam[x].answer[y]){
                                                        dataSumTopTeam += (dataTeamSelectTopTeam[x].answer[y]) * (5 - y)
                                                        maxmimumTopTeam += dataTeamSelectTopTeam[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentTopTeam = ((dataSumTopTeam * 100) / maxmimumTopTeam);
                                    }else{
                                        percentTopTeam = 0
                                    }
                                    let total:any = percentTopTeam.toFixed(1) * 1
                                    objDataTopTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'eRes') { //eRes
                                let checkData = (dataTopTeam[state.arrQuarter[temp_quarter]] && dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[1]]) ? dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[1]] : ''
                                if(checkData){
                                    let percentTopTeam:any = 0
                                    let dataSumTopTeam:any = 0;
                                    let maxmimumTopTeam:any = 0;
                                    const dataTeamSelectTopTeam: Array<any> = [];
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[1]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[2]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[3]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[4]])
                                    dataTeamSelectTopTeam.push(dataTopTeam[state.arrQuarter[temp_quarter]][selectTeam+"_"+state.questionSet2[5]])
                                    if(Object.keys(dataTeamSelectTopTeam[0]).length > 0 && Object.keys(dataTeamSelectTopTeam[1]).length > 0 && Object.keys(dataTeamSelectTopTeam[2]).length > 0 && Object.keys(dataTeamSelectTopTeam[3]).length > 0 && Object.keys(dataTeamSelectTopTeam[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectTopTeam[x] && dataTeamSelectTopTeam[x].answer && Object.keys(dataTeamSelectTopTeam[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectTopTeam[x].answer[y]){
                                                        dataSumTopTeam += (dataTeamSelectTopTeam[x].answer[y]) * (5 - y)
                                                        maxmimumTopTeam += dataTeamSelectTopTeam[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentTopTeam = ((dataSumTopTeam * 100) / maxmimumTopTeam);
                                    }else{
                                        percentTopTeam = 0
                                    }
                                    let total:any = percentTopTeam.toFixed(1) * 1
                                    objDataTopTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else {
                                    objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            } else {
                                if(state.questionType[quest_id] == 'Scale'){
                                    let total:any = topTeamValue.percent.toFixed(1) * 1
                                    objDataTopTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 5){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 5 && total < 7){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 7){
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    if(Object.keys(topTeamValue).length !== 0){
                                        let total:any = Math.ceil(topTeamValue.percent)
                                        objDataTopTeam[`q`+(temp_quarter+1)] = total
                                        if(total >= 0 && total <= 50){
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                        }else if(total > 50 && total < 70){
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                        }else if(total >= 70){
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                        }else{
                                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                        }
                                    }else{
                                        objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                                        objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }
                            }
                            if(state.questionType[quest_id] == 'NPS' || state.questionType[quest_id] == 'eNPS' || quest_id == 'WHO-5' || quest_id == 'eRes'){
                                if(objDataTopTeam[`q`+ (dataArrow[0] + 1)+`Status`] && objDataTopTeam[`q`+ (dataArrow[0] + 1)+`Status`] !== 'none'){
                                    obj['indexColor'] = objDataTopTeam[`q`+ (dataArrow[0] + 1)+`Status`]
                                }
                            }
                            if(checkArrow){
                                let quaterChange1:any = objDataTopTeam[`q`+ (dataArrow[0] + 1)]
                                let quaterChange2:any = objDataTopTeam[`q`+ (dataArrow[1] + 1)]
                                let totalChange:any = 0
                                if((quaterChange1 !== undefined) && (quaterChange2 !== undefined)){
                                    totalChange = quaterChange1 - quaterChange2
                                    if(totalChange == 0){
                                        objDataTopTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'minus'
                                    }else if(totalChange > 0){
                                        objDataTopTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'up'
                                    }else if(totalChange < 0){
                                        objDataTopTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'down'
                                    }
                                } 
                            }
                        }else{
                            objDataTopTeam[`q`+(temp_quarter+1)] = '-'
                            objDataTopTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                        }
                        ///for User Team ///
                        objDataTopTeam['children'] = new Array()
                        let userKey = teamUser+"_"+quest_id
                        let userValue = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][userKey]) ? dataUserTeam[state.arrQuarter[temp_quarter]][userKey] : {}
                        if(Object.keys(userValue).length !== 0 || quest_id == 'WHO-5' || quest_id == 'eRes'){
                            if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                let nps_score_user:any = 0
                                if(userValue.answer && Object.keys(userValue.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    _.forEach(userValue.answer, function (response, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= response
                                        }else if(key >=9 && key <= 10){
                                            promotors+= response
                                        }
                                    });
                                    nps_score_user =((promotors / Number(userValue.total)) - (detractors / Number(userValue.total)))*100
                                }
                                let total:any = Math.ceil(nps_score_user)
                                objDataUserTeam[`q`+(temp_quarter+1)] = total
                                if(total >= -100 && total <= 0){
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                }else if(total > 0 && total < 30){
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                }else if(total >= 30){
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                }else{
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'WHO-5') { //WHO-5
                                let checkData = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[1]]) ? dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[1]] : ''
                                if(checkData){
                                    const dataTeamSelectUser: Array<any> = [];
                                    let percentUser:any = 0
                                    let dataSumUser:any = 0;
                                    let maxmimumUser:any = 0;
                                    
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[1]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[2]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[3]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[4]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet1[5]])
                                    if(Object.keys(dataTeamSelectUser[0]).length > 0 && Object.keys(dataTeamSelectUser[1]).length > 0 && Object.keys(dataTeamSelectUser[2]).length > 0 && Object.keys(dataTeamSelectUser[3]).length > 0 && Object.keys(dataTeamSelectUser[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectUser[x] && dataTeamSelectUser[x].answer && Object.keys(dataTeamSelectUser[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectUser[x].answer[y]){
                                                        dataSumUser += (dataTeamSelectUser[x].answer[y]) * (5 - y)
                                                        maxmimumUser += dataTeamSelectUser[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentUser = ((dataSumUser * 100) / maxmimumUser);
                                    }else{
                                        percentUser = 0
                                    }
                                    let total:any = percentUser.toFixed(1) * 1
                                    objDataUserTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            }else if(quest_id == 'eRes') { //eRes
                                let checkData = (dataUserTeam[state.arrQuarter[temp_quarter]] && dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[1]]) ? dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[1]] : ''
                                if(checkData){
                                    const dataTeamSelectUser: Array<any> = [];
                                    let percentUser:any = 0
                                    let dataSumUser:any = 0;
                                    let maxmimumUser:any = 0;
                                    
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[1]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[2]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[3]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[4]])
                                    dataTeamSelectUser.push(dataUserTeam[state.arrQuarter[temp_quarter]][teamUser+"_"+state.questionSet2[5]])
                                    if(Object.keys(dataTeamSelectUser[0]).length > 0 && Object.keys(dataTeamSelectUser[1]).length > 0 && Object.keys(dataTeamSelectUser[2]).length > 0 && Object.keys(dataTeamSelectUser[3]).length > 0 && Object.keys(dataTeamSelectUser[4]).length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelectUser[x] && dataTeamSelectUser[x].answer && Object.keys(dataTeamSelectUser[x].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelectUser[x].answer[y]){
                                                        dataSumUser += (dataTeamSelectUser[x].answer[y]) * (5 - y)
                                                        maxmimumUser += dataTeamSelectUser[x].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        percentUser = ((dataSumUser * 100) / maxmimumUser);
                                    }else{
                                        percentUser = 0
                                    }
                                    let total:any = percentUser.toFixed(1) * 1
                                    objDataUserTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 59){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 59 && total < 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 80){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                                    objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                }
                            } else {
                                if(state.questionType[quest_id] == 'Scale'){
                                    let total:any = (userValue.percent.toFixed(1)) * 1
                                    objDataUserTeam[`q`+(temp_quarter+1)] = total
                                    if(total >= 0 && total <= 5){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                    }else if(total > 5 && total < 7){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                    }else if(total >= 7){
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }else{
                                    if(Object.keys(userValue).length !== 0){
                                        let total:any = Math.ceil(userValue.percent)
                                        objDataUserTeam[`q`+(temp_quarter+1)] = total
                                        if(total >= 0 && total <= 50){
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'red'
                                        }else if(total > 50 && total < 70){
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'yellow'
                                        }else if(total >= 70){
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'green'
                                        }else{
                                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                        }
                                    }else{
                                        objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                                        objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                                    }
                                }
                            }
                            if(checkArrow){
                                let quaterChange1:any = objDataUserTeam[`q`+ (dataArrow[0] + 1)]
                                let quaterChange2:any = objDataUserTeam[`q`+ (dataArrow[1] + 1)]
                                let totalChange:any = 0
                                if((quaterChange1 !== undefined) && (quaterChange2 !== undefined)){
                                    totalChange = quaterChange1 - quaterChange2
                                    if(totalChange == 0){
                                        objDataUserTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'minus'
                                    }else if(totalChange > 0){
                                        objDataUserTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'up'
                                    }else if(totalChange < 0){
                                        objDataUserTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'down'
                                    }
                                } 
                            }
                        }else{
                            objDataUserTeam[`q`+(temp_quarter+1)] = '-'
                            objDataUserTeam[`q`+(temp_quarter+1)+`Status`] = 'none'
                        }
                    });
                    ///for Parent Team///
                    objDataUserTeam['children'] = new Array()
                    _.forOwn(teamUserParent, function(item_parent, teamParent) {
                        let objDataParentTeam = {}
                        objDataParentTeam['id'] = teamParent
                        _.forEach(state.arrQuarter, (year_quarter_parent,temp_quarter_parent)=> {
                            if(dataParentTeam && dataParentTeam[state.arrQuarter[temp_quarter_parent]] !== undefined){
                                let parentKey = teamParent+"_"+quest_id
                                let parentValue = (dataParentTeam[state.arrQuarter[temp_quarter_parent]] && dataParentTeam[state.arrQuarter[temp_quarter_parent]][parentKey]) ? dataParentTeam[state.arrQuarter[temp_quarter_parent]][parentKey] : {}
                                if(Object.keys(parentValue).length !== 0 || quest_id == 'WHO-5' || quest_id == 'eRes'){
                                    if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][quest_id]){
                                        let nps_score_parent:any = 0
                                        if(parentValue.answer && Object.keys(parentValue.answer).length > 0){
                                            let promotors:any = 0
                                            let detractors:any = 0
                                            _.forEach(parentValue.answer, function (response, key:number) {
                                                if(key >= 0 && key <= 6){
                                                    detractors+= response
                                                }else if(key >=9 && key <= 10){
                                                    promotors+= response
                                                }
                                            });
                                            nps_score_parent =((promotors / Number(parentValue.total)) - (detractors / Number(parentValue.total)))*100
                                        }
                                        let total:any = Math.ceil(nps_score_parent)
                                        objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                        if(total >= -100 && total <= 0){
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                        }else if(total > 0 && total < 30){
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                        }else if(total >= 30){
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                        }else{
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                        }
                                    }else if(quest_id == 'WHO-5') { //WHO-5
                                        let checkData = (dataParentTeam[state.arrQuarter[temp_quarter_parent]] && dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[1]]) ? dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[1]] : ''
                                        if(checkData){
                                            const dataTeamSelectParent: Array<any> = [];
                                            let percentParent:any = 0
                                            let dataSumParent:any = 0;
                                            let maxmimumParent:any = 0;
                                            
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[1]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[2]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[3]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[4]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet1[5]])
                                            if(Object.keys(dataTeamSelectParent[0]).length > 0 && Object.keys(dataTeamSelectParent[1]).length > 0 && Object.keys(dataTeamSelectParent[2]).length > 0 && Object.keys(dataTeamSelectParent[3]).length > 0 && Object.keys(dataTeamSelectParent[4]).length > 0){
                                                for(let x=0; x<5; x++){
                                                    if(dataTeamSelectParent[x] && dataTeamSelectParent[x].answer && Object.keys(dataTeamSelectParent[x].answer).length > 0){
                                                        for(let y=0; y<6; y++){
                                                            if(dataTeamSelectParent[x].answer[y]){
                                                                dataSumParent += (dataTeamSelectParent[x].answer[y]) * (5 - y)
                                                                maxmimumParent += dataTeamSelectParent[x].answer[y] * 5
                                                            }
                                                        }
                                                    }
                                                }
                                                percentParent = ((dataSumParent * 100) / maxmimumParent);
                                            }else{
                                                percentParent = 0
                                            }
                                            let total:any = percentParent.toFixed(1) * 1
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                            if(total >= 0 && total <= 59){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                            }else if(total > 59 && total < 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                            }else if(total >= 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }else{
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                        }
                                    }else if(quest_id == 'eRes') { //eRes
                                        let checkData = (dataParentTeam[state.arrQuarter[temp_quarter_parent]] && dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[1]]) ? dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[1]] : ''
                                        if(checkData){
                                            const dataTeamSelectParent: Array<any> = [];
                                            let percentParent:any = 0
                                            let dataSumParent:any = 0;
                                            let maxmimumParent:any = 0;
                                            
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[1]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[2]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[3]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[4]])
                                            dataTeamSelectParent.push(dataParentTeam[state.arrQuarter[temp_quarter_parent]][teamParent+"_"+state.questionSet2[5]])
                                            if(Object.keys(dataTeamSelectParent[0]).length > 0 && Object.keys(dataTeamSelectParent[1]).length > 0 && Object.keys(dataTeamSelectParent[2]).length > 0 && Object.keys(dataTeamSelectParent[3]).length > 0 && Object.keys(dataTeamSelectParent[4]).length > 0){
                                                for(let x=0; x<5; x++){
                                                    if(dataTeamSelectParent[x] && dataTeamSelectParent[x].answer && Object.keys(dataTeamSelectParent[x].answer).length > 0){
                                                        for(let y=0; y<6; y++){
                                                            if(dataTeamSelectParent[x].answer[y]){
                                                                dataSumParent += (dataTeamSelectParent[x].answer[y]) * (5 - y)
                                                                maxmimumParent += dataTeamSelectParent[x].answer[y] * 5
                                                            }
                                                        }
                                                    }
                                                }
                                                percentParent = ((dataSumParent * 100) / maxmimumParent);
                                            }else{
                                                percentParent = 0
                                            }
                                            let total:any = percentParent.toFixed(1) * 1
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                            if(total >= 0 && total <= 59){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                            }else if(total > 59 && total < 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                            }else if(total >= 80){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }else{
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                        }
                                    } else {
                                        if(state.questionType[quest_id] == 'Scale'){
                                            let total:any = (parentValue.percent.toFixed(1)) * 1
                                            objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                            if(total >= 0 && total <= 5){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                            }else if(total > 5 && total < 7){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                            }else if(total >= 7){
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }else{
                                            if(Object.keys(parentValue).length !== 0){
                                                let total:any = Math.ceil(parentValue.percent)
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)] = total
                                                if(total >= 0 && total <= 50){
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'red'
                                                }else if(total > 50 && total < 70){
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'yellow'
                                                }else if(total >= 70){
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'green'
                                                }else{
                                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                                }
                                            }else{
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                            }
                                        }
                                    }
                                }else{
                                    objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                    objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                                }
                                if(checkArrow){
                                    let quaterChange1:any = objDataParentTeam[`q`+ (dataArrow[0] + 1)]
                                    let quaterChange2:any = objDataParentTeam[`q`+ (dataArrow[1] + 1)]
                                    let totalChange:any = 0
                                    if((quaterChange1 !== undefined) && (quaterChange2 !== undefined)){
                                        totalChange = quaterChange1 - quaterChange2
                                        if(totalChange == 0){
                                            objDataParentTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'minus'
                                        }else if(totalChange > 0){
                                            objDataParentTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'up'
                                        }else if(totalChange < 0){
                                            objDataParentTeam[`q`+ (dataArrow[0] + 1) + `SChange`] = 'down'
                                        }
                                    } 
                                }
                            }else{
                                objDataParentTeam[`q`+(temp_quarter_parent+1)] = '-'
                                objDataParentTeam[`q`+(temp_quarter_parent+1)+`Status`] = 'none'
                            }
                        });
                        objDataParentTeam['teamName'] = allTeam[teamParent].name || ''
                        if(selectTeam == teamUser){
                            objDataTopTeam['children'].push(objDataParentTeam)
                        }else{
                            objDataUserTeam['children'].push(objDataParentTeam)
                        }
                    });
                    objDataUserTeam['teamName'] = allTeam[teamUser].name || ''
                    if(selectTeam !== teamUser){
                        objDataTopTeam['children'].push(objDataUserTeam)
                    }
                    objDataTopTeam['teamName'] = allTeam[selectTeam].name || ''
                    obj['tableData'].push(objDataTopTeam)
                    arrDataChallenge.push(obj)
                });
                commit('setEnpsQusetionData', arrDataStrength)
                commit('setNormalQusetionData', arrDataChallenge)
                commit('setLoadingStrengthData', false)
            });
        }
    },
    getters: {
        recommendLabel: (state:any) => {
            return state.recommendLabel
        },
        loadingStrengthData: (state:any) => {
            return state.loadingStrengthData
        },
        enpsQusetionData: (state:any) => {
            return state.enpsQusetionData
        },
        normalQusetionData: (state:any) => {
            return state.normalQusetionData
        },
        questionType: (state:any) => {
            return state.questionType
        },
    }
  }